// -------------------------------------------------------------------------
// Renders the sidebar navigation for the admin tables.
//
// Displays the list of available SQL tables and highlights the currently
// selected table. Selecting a table notifies the parent component through
// onSelectTable.
// -------------------------------------------------------------------------

import React from 'react';

const TableSidebar = ({
    tables,
    selectedTable,
    onSelectTable,
}) => {

    // ---------------------------------------------------------------------
    // Render
    // ---------------------------------------------------------------------

    return (
        <nav className="adtab-sidebar">

            {/* Sidebar heading */}
            <div className="adtab-sidebar__label">
                Tables
            </div>

            {/* Available admin tables */}
            <ul className="adtab-sidebar__list">

                {tables.map(table => (

                    <li key={table.name}>

                        <button
                            className={
                                'adtab-sidebar__item' +
                                (
                                    table.name === selectedTable
                                        ? ' adtab-sidebar__item--active'
                                        : ''
                                )
                            }
                            onClick={() =>
                                onSelectTable(table.name)
                            }
                        >

                            {/* Visual indicator for the table */}
                            <span
                                className="adtab-sidebar__dot"
                                aria-hidden="true"
                            />

                            {/* Table name */}
                            <span className="adtab-sidebar__name">
                                {table.name}
                            </span>

                        </button>

                    </li>

                ))}

            </ul>

        </nav>
    );
};


export default TableSidebar;